export enum OrderStatusEnum {
  Open = 0,
  Completed = 1,
  Cancelled = 2,
}
export enum PackageOrderStatusEnum {
  Completed = 1,
  NotCompleted = 0,
}
export enum PackageProductionCompleteEnum {
  FullyComplete = 1,
  PartiallyComplete = 0,
}

export enum ScheduleOrderEnum {
  nullScheduleStartDate = 0,
  scheduleStartDate = 1,
  all = 2,
}

export enum OrderApprovalStatus {
  NotRequired = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export const orderApprovalStatusMap: Record<number, string> = {
  [OrderApprovalStatus.NotRequired]: 'Not Required',
  [OrderApprovalStatus.Pending]: 'Pending',
  [OrderApprovalStatus.Approved]: 'Approved',
  [OrderApprovalStatus.Rejected]: 'Rejected',
};
